export default __webpack_public_path__ + "static/media/icons8-x.271886b0.svg";